import i18n from "src/app/shared/localization/i18n"
export const CHANNEL_SETTING_PREFIX: string = 'Channel_';

export const EMPTY_NAME_TOOLTIP_ERROR_MESSAGE: string = i18n.t('channels.emptyNameTooltipErrorMessage');
export const INVALID_FIELDS_MESSAGE: string = i18n.t('channels.invalidFieldsMessage');